export const findFatalEntityEditValidationErrors = edits => {
    if (edits && edits.name && edits.name.includes('"')) return 'POI name cannot contain double quote character (")';

    return null;
};
